// Ottimizzazione immagini lato client: evita crash di memoria su mobile (iOS/Android) durante scansioni/foto.
// Niente FileReader/base64 (raddoppia la RAM): decodifica nativa via createImageBitmap o objectURL.
export async function compressImage(file, maxDim = 1200, quality = 0.8) {
  if (!file || !file.type || !file.type.startsWith("image/")) return file;
  try {
    let source = null, width = 0, height = 0, bitmap = null, objUrl = null;
    if (typeof createImageBitmap === "function") {
      try { bitmap = await createImageBitmap(file); } catch { bitmap = null; }
    }
    if (bitmap) {
      source = bitmap; width = bitmap.width; height = bitmap.height;
    } else {
      objUrl = URL.createObjectURL(file);
      const img = await new Promise((res, rej) => {
        const i = new Image();
        i.onload = () => res(i);
        i.onerror = rej;
        i.src = objUrl;
      });
      source = img; width = img.naturalWidth || img.width; height = img.naturalHeight || img.height;
    }
    if (!width || !height) { if (objUrl) URL.revokeObjectURL(objUrl); return file; }
    if (width <= maxDim && height <= maxDim && file.size < 700_000) {
      if (bitmap?.close) bitmap.close();
      if (objUrl) URL.revokeObjectURL(objUrl);
      return file;
    }
    const scale = Math.min(1, maxDim / Math.max(width, height));
    const w = Math.max(1, Math.round(width * scale));
    const h = Math.max(1, Math.round(height * scale));
    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    canvas.getContext("2d").drawImage(source, 0, 0, w, h);
    if (bitmap?.close) bitmap.close();
    if (objUrl) URL.revokeObjectURL(objUrl);
    const blob = await new Promise((res) => canvas.toBlob(res, "image/jpeg", quality));
    canvas.width = 0;
    canvas.height = 0;
    if (!blob) return file;
    const name = (file.name || "scan").replace(/\.\w+$/, "") + ".jpg";
    return new File([blob], name, { type: "image/jpeg" });
  } catch {
    return file;
  }
}
